import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.324 5.509a3.063 3.063 0 0 1-3.99 4.561zM7 4.437a3.063 3.063 0 0 0-2.324 5.054l3.993-4.56A3.04 3.04 0 0 0 7 4.438M12.688 7.5A5.688 5.688 0 1 1 7 1.813 5.695 5.695 0 0 1 12.688 7.5m-1.75 0a3.92 3.92 0 0 0-1.034-2.655l.268-.338a.438.438 0 1 0-.656-.576l-.269.338a3.937 3.937 0 0 0-5.151 5.886l-.268.338a.438.438 0 0 0 .656.576l.269-.338A3.935 3.935 0 0 0 10.938 7.5"
    }, null, -1)
  ]))]))
}
export default { render: render }